import { h } from 'preact'

/**
 * TypingIndicator — shows animated dots + names of people currently typing.
 *
 * Reads store.typingNames.value (computed from typingByRoom for the active room).
 * Returns null when nobody is typing.
 *
 * Props: { store }
 */
export function TypingIndicator({ store }) {
  const names = store.typingNames.value
  if (!names || names.length === 0) return null

  const label = names.length === 1
    ? `${names[0]} gépel`
    : `${names.slice(0, 2).join(', ')} gépel`

  return (
    <div class="chat-typing-container">
      <div class="chat-typing-indicator">
        <span class="chat-typing-dots">
          <span class="chat-typing-dot" />
          <span class="chat-typing-dot" />
          <span class="chat-typing-dot" />
        </span>
        <span class="chat-typing-text">{label}…</span>
      </div>
    </div>
  )
}
